import { RefObject } from "react";

import { usePlayerControls } from "./hooks/usePlayerControls";
import { usePlayerKeyboardControls } from "./hooks/usePlayerKeyboardControls";

const Controller = ({ videoRef }: { videoRef: RefObject<HTMLVideoElement> }) => {
  const { togglePlay, toggleMute, seek, isMuted, toggleFullScreen, volume, setVolumeLevel } =
    usePlayerControls(videoRef);
  

  usePlayerKeyboardControls({
    togglePlay,
    toggleMute,
    setVolumeLevel,
    seek,
    toggleFullScreen,
    volume,
    isMuted,
    videoRef,
  });
  return <></>;
};

export default Controller;
